import React, { useState, useEffect, useRef } from "react";
import ReactECharts from "echarts-for-react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import pharmacies from "./pharmacies";
import "./Pickups.css";




const Pickups = () => {
  const [pharmacyMap, setPharmacyMap] = useState([]);
  const [selectedPharmacy, setSelectedPharmacy] = useState("");
  const [selectedPharmacyId, setSelectedPharmacyId] = useState("");
  const [chartData, setChartData] = useState([]);
  const [error, setError] = useState("");
  const [allCharts, setAllCharts] = useState([]);
  const [loadingAll, setLoadingAll] = useState(false);
  const [loadingSingle, setLoadingSingle] = useState(false);
  const [pharmaciesProcessed, setPharmaciesProcessed] = useState(0);

  useEffect(() => {
    const fetchPharmacyIds = async () => {
     try {
  const token = localStorage.getItem("authToken");
  const response = await fetch("https://api.pharmacegroup.co.uk/getpharmacies", {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  const data = await response.json();
  if (!Array.isArray(data)) throw new Error("Invalid pharmacy list");

  const members = JSON.parse(localStorage.getItem("members") || "[]");
  const memberNames = members.map(m => m.pharmacyName);
  const matched = data.filter(p => memberNames.includes(p.name.trim()));

  setPharmacyMap(matched);
} catch (err) {
  console.error("Error fetching pharmacy IDs:", err);
  setError("Failed to load pharmacy list.");
}

    };

    fetchPharmacyIds();
  }, []);

  useEffect(() => {
    if (selectedPharmacy && pharmacyMap.length > 0) {
      const match = pharmacyMap.find((p) => p.name === selectedPharmacy);
      if (match && match._id) {
        setSelectedPharmacyId(match._id);
      } else {
        setSelectedPharmacyId("");
        setError("No matching pharmacyId found.");
      }
    } else {
      setChartData([]);
      setError("");
    }
  }, [selectedPharmacy, pharmacyMap]);

  useEffect(() => {
    if (selectedPharmacyId) {
      setLoadingSingle(true);
      fetchChartData(selectedPharmacyId).then((data) => {
        setChartData(data || []);
        setLoadingSingle(false);
      });
    }
  }, [selectedPharmacyId]);

  const fetchChartData = async (pharmacyId) => {
     try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `https://api.pharmacegroup.co.uk/prescriptions?pharmacyId=${encodeURIComponent(pharmacyId)}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      if (!response.ok) throw new Error(`API error: ${response.status}`);
      const data = await response.json();

      const filtered = data.filter((item) => {
        if (!item.handOverDate || !item.putOnShelfDate || item.isDeleted || item.driverId) return false;
        const diffMinutes = (new Date(item.handOverDate) - new Date(item.putOnShelfDate)) / (1000 * 60);
        return diffMinutes >= 10;
      });

      const weekGroups = {};
      filtered.forEach((item) => {
        const start = new Date(item.putOnShelfDate);
        const end = new Date(item.handOverDate);
        const diffHours = (end - start) / (1000 * 60 * 60);
        const week = new Date(start.getFullYear(), start.getMonth(), start.getDate() - start.getDay())
          .toISOString()
          .split("T")[0];
        const key = item.messageSent ? "with" : "without";

        if (!weekGroups[week]) {
          weekGroups[week] = { with: [], without: [] };
        }
        weekGroups[week][key].push(diffHours);
      });

      return Object.entries(weekGroups)
        .map(([week, { with: withMsgs, without: withoutMsgs }]) => {
          const avg = (arr) =>
            arr.length ? parseFloat((arr.reduce((sum, t) => sum + t, 0) / arr.length).toFixed(2)) : null;
          return {
            week,
            withMsgAvg: avg(withMsgs),
            withCount: withMsgs.length,
            withoutMsgAvg: avg(withoutMsgs),
            withoutCount: withoutMsgs.length,
          };
        })
        .filter((d) => d.withMsgAvg !== null || d.withoutMsgAvg !== null)
        .sort((a, b) => new Date(a.week) - new Date(b.week));
    } catch (err) {
      console.error("Fetch error:", err);
      return null;
    }
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleShowAll = async () => {
    setLoadingAll(true);
    setAllCharts([]);
    setPharmaciesProcessed(0);
    const results = [];

    for (const name of pharmacies) {
      const match = pharmacyMap.find((p) => p.name === name);
      if (!match || !match._id) {
        console.log(`Skipping ${name}: No matching ID`);
        setPharmaciesProcessed((prev) => prev + 1);
        continue;
      }

      const data = await fetchChartData(match._id);
      if (data) {
        results.push({ name, data });
      }
      setPharmaciesProcessed((prev) => prev + 1);
      await delay(200);
    }

    setAllCharts(results);
    setLoadingAll(false);
  };

  const handleExportPDF = async () => {
    const pdf = new jsPDF("p", "mm", "a4");
    const chartElements = document.querySelectorAll(".chart-container");

    for (let i = 0; i < chartElements.length; i++) {
      const canvas = await html2canvas(chartElements[i]);
      const imgData = canvas.toDataURL("image/png");
      const pageWidth = 210;
      const imgHeight = (canvas.height * pageWidth) / canvas.width;
      if (i !== 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, 10, pageWidth, imgHeight);
    }

    pdf.save("bag-collection-report.pdf");
  };

  const handlePharmacyChange = (e) => {
    setSelectedPharmacy(e.target.value);
    setAllCharts([]);
  };

  const getLineChartOption = (data, name) => ({
    title: { text: name || "", left: "center" },
    tooltip: {
      trigger: "axis",
      formatter: (params) =>
        params
          .map((p) => {
            const label = p.seriesName;
            const value = p.value;
            const count =
              p.seriesName === "With Message"
                ? data[p.dataIndex].withCount
                : data[p.dataIndex].withoutCount;
            return `${label}<br/>Delay: ${value} hrs<br/>Count: ${count}`;
          })
          .join("<br/><br/>"),
    },
    legend: {
      data: ["With Message", "Without Message"],
      top: 30,
    },
    xAxis: {
      type: "category",
      data: data.map((d) => d.week),
    },
    yAxis: {
      type: "value",
      name: "Hours",
    },
    series: [
      {
        name: "With Message",
        type: "line",
        data: data.map((d) => d.withMsgAvg),
        smooth: true,
        lineStyle: { color: "#4caf50" },
      },
      {
        name: "Without Message",
        type: "line",
        data: data.map((d) => d.withoutMsgAvg),
        smooth: true,
        lineStyle: { color: "#f44336" },
      },
    ],
  });

  const getBarChartOption = (data) => ({
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
    },
    legend: {
      data: ["With Message", "Without Message"],
      top: 30,
    },
    xAxis: {
      type: "category",
      data: data.map((d) => d.week),
    },
    yAxis: {
      type: "value",
      name: "Number of Bags",
    },
    series: [
      {
        name: "With Message",
        type: "bar",
        stack: "bags",
        data: data.map((d) => d.withCount),
        itemStyle: { color: "#4caf50" },
      },
      {
        name: "Without Message",
        type: "bar",
        stack: "bags",
        data: data.map((d) => d.withoutCount),
        itemStyle: { color: "#f44336" },
      },
    ],
  });

  return (
    <div className="pickups-container">
      <h2>Bag Collection Times</h2>

      <label>Select Pharmacy: </label>
<select value={selectedPharmacy} onChange={handlePharmacyChange}>
  <option value="">-- Select --</option>
  {pharmacyMap.map((pharmacy, idx) => (
    <option key={idx} value={pharmacy.name}>
      {pharmacy.name}
    </option>
  ))}
</select>

      <button onClick={handleShowAll} style={{ marginLeft: "10px" }}>
        Show All
      </button>

      <button onClick={handleExportPDF} style={{ marginLeft: "10px" }}>
        Export to PDF
      </button>

      {(loadingAll || loadingSingle) && (
        <p style={{ marginTop: "20px", fontSize: "20px", color: "orange" }}>
          Please wait while retrieving... this will take a minute
          <br />
          Pharmacies analysed: {pharmaciesProcessed} / {pharmacies.length}
        </p>
      )}

      {error && <p style={{ color: "red" }}>{error}</p>}

      {chartData.length > 0 && !allCharts.length && (
        <>
          <div className="chart-container" style={{ width: "100%", height: 400, marginTop: "20px" }}>
            <ReactECharts option={getLineChartOption(chartData, selectedPharmacy)} />
          </div>
          <div className="chart-container" style={{ width: "100%", height: 400, marginTop: "20px" }}>
            <ReactECharts option={getBarChartOption(chartData)} />
          </div>
        </>
      )}

      {allCharts.map((chart, idx) => (
        <div key={idx}>
          <h4>{chart.name}</h4>
          <div className="chart-container" style={{ width: "100%", height: 400, marginTop: "20px" }}>
            <ReactECharts option={getLineChartOption(chart.data)} />
          </div>
          <div className="chart-container" style={{ width: "100%", height: 400, marginTop: "20px" }}>
            <ReactECharts option={getBarChartOption(chart.data)} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Pickups;
